import React, { Component } from 'react';
import { SimpleForm, TextInput, NumberInput, translate } from 'react-admin';
import RichTextInputWithSource from '~components/RichTextInputWithSource';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

class DisclaimerForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props}>
        {this.props.children}
        <FieldGroup label="fieldGroups.disclaimerEs">
          <TextInput source="titleEs" />
          <RichTextInputWithSource source="disclaimerEs" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.disclaimerEn">
          <TextInput source="titleEn" />
          <RichTextInputWithSource source="disclaimerEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.disclaimerPt">
          <TextInput source="titlePt" />
          <RichTextInputWithSource source="disclaimerPt" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.disclaimer">
          <NumberInput source="order" />
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(DisclaimerForm);
